import '../userStyle.scss';
import { Col, Steps } from 'antd';
import React, { Component } from 'react';
import AgreementPage from '../menus/payroll-agreement/agreement-page';
import AuthorizedSignatoryPage from '../menus/Authorized-Signature/authorized-signatory-page';
import CompanyInfoPage from '../menus/Company-info/company-info-page';
import CongratulationPage from '../menus/Congratulation page/congratulation-page';
import ContactInfoPage from '../menus/Contact-info/contact-info-page';
import DeliveryCardPage from '../menus/Delivery-card page/delivery-card-page';
import SignaturePage from '../menus/Signature/signature-page';
import SummaryPage from '../menus/summarypage/summary-page';
import { StepRoutes } from '@routes';
import Selectors from '../menus/salesforce-landing/selectors';
import { connect } from 'react-redux';
const { Step } = Steps;

class MainStepper extends Component {
	constructor(props) {
		super(props);
		this.validate = this.validate.bind(this);
		this.handleNavigation = this.handleNavigation.bind(this);
		this.changeButtonMode = this.changeButtonMode.bind(this);
		this.setButtonName = this.setButtonName.bind(this);
		this.setCompanyinfo = this.setCompanyinfo.bind(this);
		this.state = {
			companyinfo: {},
			stepIndex: 0,
			stepLabels: [
				{ title: 'Company Info', count: 1, pageIndex: 0, route: '/user/companyinfo', disable: false },
				{ title: 'Contact Info', count: 2, pageIndex: 1, route: '/user/contactinfo/1', disable: false },
				{ title: 'Signature', count: 3, pageIndex: 3, route: '/user/signature/1', disable: true },
			],
			buttonName: 'Next',

			visited: [],
			timeLineIndex: 0,
			isNavigateisDisabled: true,
			wasReviewed: false,
			buttonMode: 'single',
			Component: [
				<CompanyInfoPage
					allowNavigate={this.handleNavigation}
					navigateDisabled={this.validate}
					buttonMode={this.changeButtonMode}
					buttonName={this.setButtonName}
					getCompanyList={this.getCompanyinfo}
				/>,
				<ContactInfoPage
					allowNavigate={this.handleNavigation}
					navigateDisabled={this.validate}
					buttonMode={this.changeButtonMode}
					buttonName={this.setButtonName}
				/>,
				<DeliveryCardPage
					allowNavigate={this.handleNavigation}
					buttonMode={this.changeButtonMode}
					buttonName={this.setButtonName}
					navigateDisabled={this.validate}
					companyInfoDetails={this.setCompanyinfo}
				/>,
				<SummaryPage buttonMode={this.changeButtonMode} buttonName={this.setButtonName} />,
				<SignaturePage allowNavigate={this.handleNavigation} buttonMode={this.changeButtonMode} />,
				<AgreementPage buttonMode={this.changeButtonMode} buttonName={this.setButtonName}></AgreementPage>,
				<AuthorizedSignatoryPage buttonMode={this.changeButtonMode} buttonName={this.setButtonName} navigateDisabled={this.validate} />,
				<CongratulationPage buttonMode={this.changeButtonMode} buttonName={this.setButtonName}></CongratulationPage>,
			],
		};
	}

	setCompanyinfo = () => {
		return this.state.companyinfo;
	};

	getCompanyinfo = (value) => {
		this.setState({ companyinfo: value });
	};

	validate(value) {
		this.setState({ isNavigateisDisabled: value });
	}

	setButtonName = (value) => {
		this.setState({ buttonName: value });
	};

	changeButtonMode = (value) => {
		this.setState({ buttonMode: value });
	};

	editStep = (number) => {
		this.setState({ stepIndex: number });
	};

	onChange = (stepindex) => {
		this.setState({ stepIndex: stepindex == 2 ? 4 : stepindex });
	};

	handleNavigation = (pageIndex) => {
		this.setState({ timeLineIndex: pageIndex });
	};

	handleNext = () => {
		this.setState((prevState) => ({
			stepIndex: prevState.stepIndex + 1,
			visited: prevState.visited.concat(prevState.stepIndex).filter((val, idx, arr) => arr.indexOf(val) === idx),
			wasReviewed: prevState.visited.length > 1 && true,
		}));
	};
	handlePrev = () => {
		this.setState((prevState) => ({ stepIndex: prevState.stepIndex - 1 }));
	};
	render() {
		const { stepIndex, stepLabels, wasReviewed } = this.state;

		return (
			<div style={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }}>
				<Col xl={10} lg={10} md={12} sm={20} xs={23}>
					<Steps className="stepWrapper" labelPlacement="vertical" current={this.props.step} onChange={(e) => this.onChange(e)}>
						{this.props.stepLabels.map(({ title, disable, count, pageIndex, route }, key) => {
							return (
								<Step
									className="steppertitle"
									key={key}
									className={wasReviewed ? 'steps-clickable' : ''}
									onClick={() => {
										if (!disable) {
											this.props.history.push(route);
										}
									}}
									title={title}
									count={count}
									disabled={disable}
								/>
							);
						})}
					</Steps>
					<div className="component_container">
						<StepRoutes />
					</div>
				</Col>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		stepLabels: Selectors.stepLabels(state),
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		getOpportunityInfoStart: (history, optId) => {},
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(MainStepper);
export default Connected;
